import request from "./index";

export function newList(data) {
  return request({
    url: "api/news/listByPageModel",
    method: "post",
    data
  })
}

export function newDetail(id) {
  return request({
    url: `api/news/${id}/simple`,
    method: "get"
  })
}

/**
 * 留资接口
 * @param {*} data
 * @returns
 */
export function createMessage(data) {
  return request({
    url: 'api/leave',
    method: 'post',
    data
  })
}

/**
 * 删除测试的留资信息
 * @param {*} id
 * @returns
 */
export function delMessage(id) {
  return request({
    url: 'api/leave/' + id,
    method: 'delete',
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js